// Full Updated AllTaskCalendarForManager.js
import React, { Component, useState, useRef } from "react";
import ReactDOM from "react-dom";
import moment from 'moment';
import {
  DetailsOfTask,
  ListTask,
  AddEditTask,
  AllTaskCalenderForManager,
  UnlockRequest
} from "../index";
import Scheduler, {
  SchedulerData,
  ViewTypes,
} from "react-big-scheduler";
import withDragDropContext from "../../../withDnDContext";
import { connect } from "react-redux";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-scheduler/lib/css/style.css";
import { Overlay, Tooltip, Button } from "react-bootstrap";
import { faWindowClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-big-calendar/lib/css/react-big-calendar.css";
import api from "../../../apis/api";
import "../../../style/calendarclass.css";

const localizer = momentLocalizer(moment);
const IconStyle = { cursor: "pointer" };
let taskc = [];
let holidaylist = [];
let schedulerData = new SchedulerData(
  new Date(),
  ViewTypes.Week,
  false,
  false,
  {}
);

const TooltipContent = ({ onClose, event }) => (
  <>
    <FontAwesomeIcon icon={faWindowClose} className="pull-right" style={IconStyle} onClick={onClose} />
    <div>Project - {event.event.projectName}</div>
    <div>{event.title}</div>
    <div>Description - {event.event.description}</div>
    <div>Hours Billable - {event.event.HoursBillable}</div>
    <div>Hours Spent - {event.event.Hoursspent}</div>
    <div>Status - {event.event.status}</div>
  </>
);

function Event(event) {
  const [showTooltip, setShowTooltip] = useState(false);
  const ref = useRef(null);
  return (
    <div ref={ref}>
      <span onMouseOver={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>{event.title}</span>
      <Overlay rootClose target={() => ReactDOM.findDOMNode(ref.current)} show={showTooltip} placement="top" onHide={() => setShowTooltip(false)}>
        <Tooltip id="tooltip"><TooltipContent event={event} onClose={() => setShowTooltip(false)} /></Tooltip>
      </Overlay>
    </div>
  );
}

class Basic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarShedularData: {},
    };
  }

  componentDidMount() {
    const { selectedTask } = this.props;
    this.dataPopulationReactScheduler(selectedTask);
  }

  componentDidUpdate(prevProps) {
    const { fullTaskArr } = this.props.fullTaskArr;
    if (prevProps.fullTaskArr.fullTaskArr.length !== fullTaskArr.length) {
      this.dataPopulationReactScheduler(fullTaskArr);
    }
  }

  dataPopulationReactScheduler = (fullTaskArr) => {
    let resources = this.getProjectNames(fullTaskArr);
    let events = this.getEvents(fullTaskArr);

    events.forEach((event, index) => {
      const requiredFields = ['id', 'start', 'end', 'resourceId', 'title'];
      requiredFields.forEach(field => {
        if (!event[field]) {
          console.error(`Invalid event at index ${index}: missing ${field}`, event);
        }
      });
    });

    const calendarData = { resources, events };
    schedulerData.setResources(calendarData.resources);
    schedulerData.setEvents(calendarData.events);
    schedulerData.config.schedulerWidth = "80%";

    this.setState({
      calendarShedularData: schedulerData,
      calendarData,
    });
  };

  getProjectNames = (fullTaskArr) => {
    return Array.from(new Set(fullTaskArr.map(t => t.projectID))).map(id => ({
      id,
      name: fullTaskArr.find(el => el.projectID === id)?.projectName || "Unknown"
    }));
  };

  getEvents = (fullTaskArr) => {
    taskc = [];
    holidaylist = [];
    this.props.fullTaskArr.recandholidayList.forEach(hol => holidaylist.push(hol));

    const isByEmployee = this.props.handelIsprojectOrEmployee === '1';
    const maplist = fullTaskArr.map(obj => ({
      value: isByEmployee ? obj.employeeID : obj.projectID,
      label: isByEmployee ? obj.employeeName : obj.projectName
    }));
    const filtered = maplist.filter((v, i, a) => a.findIndex(v2 => v2.value === v.value) === i);
    filtered.forEach(els => taskc.push({ value: els.value, project: els.label, label: "#" + (Math.random().toString(16).substr(-6)) }));

    const allEvents = fullTaskArr.map((el, index) => {
      const start = el.startTime ? el.startTime.split(" ")[1] : "09:30:00";
      const end = el.endTime ? el.endTime.split(" ")[1] : "13:30:00";
      const colorRef = taskc.find(t => t.value === (isByEmployee ? el.employeeID : el.projectID));
      return {
        id: el.employeeTimeSheetId ?? `temp-${index}`,
        start: moment(el.workDate).format('YYYY-MM-DD') + " " + start,
        end: moment(el.workDate).format('YYYY-MM-DD') + " " + end,
        resourceId: isByEmployee ? el.employeeID ?? 0 : el.projectID ?? 0,
        projectName: el.projectName ?? "Unknown",
        title: el.issueTitle ?? "Untitled",
        status: el.timeSheetStatus === 1 ? "New" : (el.timeSheetStatus === 2 ? "In Progress" : "Completed"),
        Hoursspent: el.hoursSpent ?? 0,
        HoursBillable: el.hoursBillable ?? 0,
        hexColor: colorRef?.label || "#999999",
        description: el.description ?? "",
      };
    });

    const holidayEvents = holidaylist.map((el, i) => ({
      id: `holiday-${i + 1}`,
      start: moment(el.holidayDate).format('YYYY-MM-DD') + " 09:30:00",
      end: moment(el.holidayDate).format('YYYY-MM-DD') + " 13:30:00",
      resourceId: 1,
      projectName: "Holiday",
      title: el.title ?? "Holiday",
      status: "Completed",
      Hoursspent: 0,
      HoursBillable: 0,
      hexColor: "#FF0000",
      description: el.title ?? "",
    }));

    return [...allEvents, ...holidayEvents];
  }

  render() {
    const { calendarShedularData } = this.state;
    return (
      <div>
        <br />
        <div>
          {taskc.map((va, l) => (
            <div key={l} style={{ display: 'inline-flex', alignItems: 'center', marginRight: 10 }}>
              <label>{va.project}</label>
              <Button style={{ background: va.label, height: '27px', marginLeft: 5 }}></Button>
            </div>
          ))}
        </div>
        {Object.keys(calendarShedularData).length > 0 && (
          <div style={{ height: "500pt" }}>
            <Calendar
              tooltipAccessor={null}
              components={{ event: Event }}
              events={calendarShedularData.events}
              startAccessor={event => new Date(event.start)}
              endAccessor={event => new Date(event.end)}
              defaultDate={moment().toDate()}
              localizer={localizer}
              style={{ height: 600 }}
              eventPropGetter={event => ({ style: { backgroundColor: event.hexColor, opacity: 0.8 } })}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fullTaskArr: state.taskReducer,
});

export default connect(mapStateToProps, {})(withDragDropContext(Basic));
